function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPromotionTagRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 11a2 2 0 11.001-4.001A2 2 0 019 11zm6.396-9H4.061A2.061 2.061 0 002 4.061v11.335l11.215 11.215 13.396-13.396L15.396 2zM29.396 16l-1.37-1.371-13.397 13.396L16 29.395a2.061 2.061 0 002.916 0l10.48-10.48a2.061 2.061 0 000-2.915z",
    fill: props.color
  }));
}

export default SvgIconPromotionTagRexFilled;